export { TREE } from 'hfty-soil-jobs/src/constants'// 'soilJobData' (Aug2017)
export const BRANCH = 'grids'

export const DEFAULT_GRID_TRANSFORMATIONS = {
  size: 5,
  rotation: 0,
  offset: null,
}

export const SMALL_FIELD_BREAK = 20000 // equal to 5 acres
export const DEFAULT_BOX_SCALE = 2
